import { render, staticRenderFns } from "./ServicePointForm.vue?vue&type=template&id=a22d764c&scoped=true&"
import script from "./ServicePointForm.vue?vue&type=script&lang=ts&"
export * from "./ServicePointForm.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointForm.vue?vue&type=style&index=0&id=a22d764c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22d764c",
  null
  
)

export default component.exports